var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgWav = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 22,
    viewBox: "0 0 37 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5311 14L16.0853 7.5H14.4036L13.5584 12.208L12.417 7.5H10.6877L9.5464 12.208L8.70985 7.5H7L8.55422 14H10.4997L11.5481 9.65081L12.5857 14H14.5311Z",
    fill: "#00C650"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9403 12.8133H18.502L18.0978 14H16.4441L18.8219 7.54539H20.6333L23.0111 14H21.338L20.9403 12.8133ZM20.5339 11.6179L19.7255 9.22929L18.9084 11.6179H20.5339Z",
    fill: "#00C650"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8376 7.5L26.4286 12.3918L28.0196 7.5H29.7013L27.4402 14H25.4083L23.1559 7.5H24.8376Z",
    fill: "#00C650"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16833 2.5C1.87589 2.5 0 4.37174 0 6.70259V15.2974C0 17.6283 1.87589 19.5 4.16833 19.5H32.8317C35.1241 19.5 37 17.6283 37 15.2974V6.70259C37 4.37174 35.1241 2.5 32.8317 2.5H4.16833ZM0.973684 6.70259C0.973684 4.94367 2.39431 3.5 4.16833 3.5H32.8317C34.6057 3.5 36.0263 4.94368 36.0263 6.70259V15.2974C36.0263 17.0563 34.6057 18.5 32.8317 18.5H4.16833C2.39431 18.5 0.973684 17.0563 0.973684 15.2974V6.70259Z",
    fill: "#00C650"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWav);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wav.151fa01e7283750d986d8ee8eecca7e7.svg";